import { Collection, Comment } from "../../../../models"
import { ErrorFetchingAction, FetchErrorInfo, FetchRequestActions, StartFetchingAction, SuccessFetchingAction } from "../../../../utils/request-actions-helpers/createRequestActions"
import { getGroupForDocumentActionTypes, getGroupForMoveMenuActionTypes } from "./actions"
import { getUpdatedViewsAfterMove, SetDocStatusGroup } from "./actions/helpers"
import { DocumentGroupState } from "./documentGroupReducer"


export const initialMoveMenuContextGroupState: DocumentGroupState = {

}
export const moveMenuContextGroupReducer = (state: DocumentGroupState = initialMoveMenuContextGroupState, action: FetchRequestActions<Collection>): DocumentGroupState => {
    switch (action.type) {
        case getGroupForDocumentActionTypes.start:
        case getGroupForMoveMenuActionTypes.start: {
            const startFetchingAction = action
            const newState: DocumentGroupState = {
                ...state,
                isFetching: true,
            }

            return newState
        }
        case getGroupForDocumentActionTypes.success:
        case getGroupForMoveMenuActionTypes.success: {
            const successAction = action as SuccessFetchingAction<Collection>

            const newState: DocumentGroupState = {
                groupId: successAction.result.collectionGroup.groupUid,
                item: successAction.result,
                isFetching: false
            }
            return newState
        }
        case "SET_DOCUMENT_STATUS_GROUP": {
            const successAction = action as SetDocStatusGroup
            if(!state.item) return state

            const kanbanView = state.item.collectionViews.find(view => view.collectionViewType === 'Kanban')
            if(!kanbanView) return state

            kanbanView.itemLists = getUpdatedViewsAfterMove(kanbanView.itemLists, successAction.docId, successAction.toLaneId)
            const collectionViews = state.item.collectionViews.map((view) => view.collectionViewType === 'Kanban' ? kanbanView : view)

            return {
                ...state,
                item: {
                    ...state.item,
                    collectionViews 
                }
            }
        }
        case getGroupForDocumentActionTypes.error:
        case getGroupForMoveMenuActionTypes.error: {

            const newState: DocumentGroupState = {
                isFetching: false,
                fetchError: (action as ErrorFetchingAction<any>).error,
            }
            return newState
        }

        default:
            return state
    }
}